import { Outlet } from "react-router-dom";
import AppLayout from "@/layouts/AppLayout";

export default function PaymentIdLayout() {
  return (
    <AppLayout navLinks={[]} interior bottomBar>
      <div data-testid="payment-detail-page">
        <Outlet />
      </div>
    </AppLayout>
  );
}
